// js code to get filiates functionalities

var currentUrl, currentId, languageSelector, filial;
var internUrls,
  loadedUrls = [];

var NOT_PUBLISHED_LANGUAGES = [];

// Language switcher functionality
jQuery(document).ready(function () {
  currentUrl = $("html").attr("lang"); //window.location.pathname;
  currentId = $("meta[name=hugo-id]").data("hugo-id");
  languageSelector = $(".languageUl");
  filial = $("html").data("filial");
  addPreloader($(".showLang"));
  if (ls2.load("preloadURLs") === false) {
    //*Solo la primera vez para cargar todos los idiomas*//
    loadLanguage("/assets/flagships_hreflang.json", currentId, currentUrl);
  } else {
    var idiomas = ls2.load("preloadURLsIdiomas");
    var response = ls2.load("preloadURLs");
    createLangTree(idiomas);
    changeLangURLs(response[currentId]);
  }
});
var loadLanguage = function (_url, currentId, currentUrl) {
  var datosResp = AjaxControl.cargarAjax("GET", _url).complete(function (
    data,
    XMLHttpRequest
  ) {
    if (XMLHttpRequest == "error") {
      var response = data.responseJSON;
    } else {
      var responseOk = data.responseJSON,
        idiomas = responseOk.home_web_corporativa,
        listado = [];
      idiomas.sort(function (a, b) {
        var nameA = a.text.toLowerCase(),
          nameB = b.text.toLowerCase();
        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;
        return 0;
      });
      /*Pongo el ingles como primer idioma*/
      //var first = idiomas.splice(arrayObjectIndexOf(idiomas, "eng", "langcode"), 1);
      //idiomas.unshift(first[0]);
      /*Pongo el chino el ultimo idioma*/
      //var last = idiomas.splice(arrayObjectIndexOf(idiomas, "cn-CN", "langcode"), 1);
      //idiomas.push(last[0]);
      /**/
      ls2.save("preloadURLsIdiomas", idiomas, 180000);
      ls2.save("preloadURLs", responseOk, 180000);
      createLangTree(idiomas);
      changeLangURLs(responseOk[currentId]);
    }
  });
};
var changeLangURLs = function (current) {
  $.each(current, function (key, value) {
    _url = value.url;
    langcode = value.langcode;
    var $elem = $(".language-link[data-langcode='" + langcode + "']");
    if (typeof $elem == "object") {
      $elem.attr("href", _url);
    }
  });
};
var createLangTree = function (idiomas) {
  $.each(idiomas, function (key, value) {
    if (value.hreflang == currentUrl) {
      var selectedText = value.text;
      selectedText += "<span class='flag " + value.flag_class + "'></span>";
      $(".changeLang").html(selectedText);
    }

    //TODO: temporary fix to not show some languages
    if (NOT_PUBLISHED_LANGUAGES.indexOf(value.langcode) != -1) {
      return;
    }

    var liElement = getLanguageElement(value);
    languageSelector.append(liElement);
    getLanguageElement(value);
    $(".showLang .loader-wrapper").remove();
  });
};
var getLanguageElement = function (element) {
  var liUrl = element.url ? element.url : "/" + element.hreflang;
  var liElement = "<li>";
  liElement +=
    '<a class="language-link" data-gtm-category="lang-selector" data-event="click-' +
    element.text +
    '" lang="' +
    element.lang +
    '" data-langcode="' +
    element.langcode +
    '" href="' +
    liUrl;
  if (element.langcode != "cn-CN") {
    liElement += '?multilink=switch">';
  } else {
    liElement += '">';
  }
  liElement += '<span class="flag ' + element.flag_class + '">' + "</span>";
  liElement += element.text + "</a></li>";

  return liElement;
};
// Language redirect
$(document).ready(function () {
  var country = $.cookie("geoip_isdin_country");

  if (typeof country !== "string") {
    $.ajax({
      method: "GET",
      url: "//geoip.isdin.com",
      dataType: "json",
      success: setInitialLang,
      error: function (response) {
        console.log(response);
      },
    });
  } else {
    //setRedirect();
  }

  function setInitialLang(response) {
    var hasCookie = $.cookie("geoip_isdin_country");
    usLightbox(response);
    beLightbox(response, hasCookie);
    jQuery.cookie("geoip_isdin_country", response.country, {
      path: "/",
      domain: COOKIE_DOMAIN,
    });
    //setRedirect();
  }

  function setRedirect() {
    var currentUrl = window.location.pathname;
    var currentPrefix = $("meta[name=url-prefix]").data("url-prefix");
    var currentId = $("meta[name=hugo-id]").data("hugo-id");
    var currentLangCode = $("meta[name=lang-code]").data("lang-code");

    var getParameters = "";
    var queryString = getQueryString();
    var redirect = false;

    if ("multilink" in queryString && queryString.multilink == "switch") {
      jQuery.cookie("multilink_pl", currentLangCode, {
        path: "/",
        domain: COOKIE_DOMAIN,
      });
      redirect = true;
      delete queryString.multilink;
    }

    if (!jQuery.isEmptyObject(queryString)) {
      getParameters = "?" + jQuery.param(queryString);
    }
    if (redirect) {
      window.location = currentUrl + getParameters;
      return;
    }

    var url = "/language-access/get-redirect.json";

    if (currentPrefix !== "" && currentPrefix !== null) {
      url = "/" + currentPrefix + url;

      currentUrl = currentUrl.split("/");
      if (currentUrl.length > 0 && currentUrl.indexOf(currentPrefix) == 1) {
        currentUrl.splice(1, 1);
      }
      currentUrl = currentUrl.join("/");
    }

    if (
      $("html").attr("urlfiliate") !== "https://www.nutraseb.com/" &&
      $("html").attr("urlfiliate") !== "it" &&
      $.cookie("geoip_isdin_country")
    ) {
      currentUrl = currentUrl.replace(/^\//, "");
      if (filial !== "microsites") {
        $.ajax({
          url: DRUPAL_URL + url,
          data: {
            href: currentUrl,
            id: currentId,
          },
          dataType: "jsonp",
          statusCode: {
            302: function (data) {
              var redirect;
              if (
                data.responseJSON.request !== undefined &&
                data.responseJSON.request !== null &&
                data.responseJSON.request !== ""
              ) {
                redirect = data.responseJSON.request;
              } else if (
                data.request !== undefined &&
                data.request !== null &&
                data.request !== ""
              ) {
                redirect = data.request;
              }
              if (
                redirect !== undefined &&
                redirect !== null &&
                redirect !== ""
              ) {
                window.location = redirect + getParameters;
              }
              // console.log(redirect);
            },
          },
        });
      }
    }
  }
});

var ls2 = {
  save: function (key, jsonData, expirationMS) {
    if (typeof Storage == "undefined") {
      return false;
    }
    //var expirationMS = expirationMin * 60 * 1000;
    var record = {
      value: JSON.stringify(jsonData),
      timestamp: new Date().getTime() + expirationMS,
    };
    localStorage.setItem(key, JSON.stringify(record));
    return jsonData;
  },
  load: function (key) {
    if (typeof Storage == "undefined") {
      return false;
    }
    var record = JSON.parse(localStorage.getItem(key));
    if (!record) {
      return false;
    }
    return new Date().getTime() < record.timestamp && JSON.parse(record.value);
  },
};
